import styles from "./MainBlock.module.scss";
import MainBlob from "../../animate/MainBlob";
import Image from "next/image";
import React from "react";

function MainBlock({ dictionary, mainBlockData, children }) {
	return (
		<section className={styles.container}>
			<div className={styles.info}>
				<div className={styles.text}>
					<h1 className={styles.title}>{dictionary[mainBlockData.title] || <div dangerouslySetInnerHTML={{ __html: mainBlockData.title }} />}</h1>
					<p className={styles.description}>{dictionary[mainBlockData.description] || mainBlockData.description}</p>
				</div>
				{mainBlockData.videoUrl && <video poster={mainBlockData.posterUrl} width="495" height="355" src={mainBlockData.videoUrl} autoPlay loop muted playsInline className={styles.video} />}
				{mainBlockData.mainPicture && <Image src={mainBlockData.mainPicture} alt={mainBlockData.title} className={styles.video} quality={85} width="495" height="355" />}
			</div>

			<div className={styles.inputWrapper}>{children}</div>
			<MainBlob isBack={true} />
		</section>
	);
}

export default MainBlock;
